import React, {useState, useRef} from 'react';

import * as S from './PaxWidget.styles';

import {convertToRoomString, splitRoomString} from '../../../../../shared/utils/room-string-utils';

import useChildAgePicker from '../../../../../shared/hooks/useChildAgePicker';
import ArrowDownIcon from '../../../../Icons/ArrowDownIcon';
import useOutsideClick from '../../../../../shared/hooks/useOutsideClick';

const PaxWidget = React.forwardRef(
  (props: {togglePaxWidget; roomString; updateQueryCaller; gaHandler; updateSearch}, ref) => {
    const {togglePaxWidget, roomString, updateQueryCaller, gaHandler, updateSearch} = props;
    const {
      roomCount: roomCountInState,
      paxCount: paxCountInState,
      childCount: childCountInState,
      childAgeArray,
    } = splitRoomString(roomString);

    const [adultCount, setAdultCount] = useState(paxCountInState);
    const [roomCount, setRoomCount] = useState(roomCountInState);
    const [childCount, setChildCount] = useState(childCountInState);

    const [childAgeArrayInState, actionHandler, setChildAgeArrayInState] = useChildAgePicker({
      minLimit: 1,
      maxLimit: 12,
      defaultVal: childAgeArray,
    });

    const doneClickHandler = () => {
      const roomStringVal = convertToRoomString({
        roomCount,
        paxCount: adultCount,
        childCount,
        childAgeArray: childAgeArrayInState,
      });
      updateQueryCaller({
        roomString: roomStringVal,
      });
      updateSearch();
      togglePaxWidget(false);
      gaHandler('pax', roomStringVal);
    };

    return (
      <S.WrapperDiv ref={ref}>
        <S.ContentWrapperDiv>
          <S.ContentItemWrapperDiv>
            <S.ContentItemTextWrapperSpan>
              Rooms
              <S.ContentItemConditionTextWrapperSpan>(Max 8)</S.ContentItemConditionTextWrapperSpan>
            </S.ContentItemTextWrapperSpan>
            <S.ContentActionWrapperDiv>
              <S.ContentActionIconWrapperSpan
                onClick={() => {
                  if (roomCount === 1) {
                    alert('Minimum 1 is required');
                    return;
                  } else {
                    setRoomCount(roomCount - 1);
                  }
                }}
              >
                -
              </S.ContentActionIconWrapperSpan>
              <S.ContentActionValueWrapperSpan>{roomCount}</S.ContentActionValueWrapperSpan>

              <S.ContentActionIconWrapperSpan
                onClick={() => {
                  if (roomCount > 7) {
                    alert('Max allowed upto 8');
                    return;
                  } else {
                    if (roomCount + 1 > adultCount) {
                      setAdultCount(adultCount + 1);
                    }
                    setRoomCount(roomCount + 1);
                  }
                }}
              >
                +
              </S.ContentActionIconWrapperSpan>
            </S.ContentActionWrapperDiv>
          </S.ContentItemWrapperDiv>
          <S.ContentItemWrapperDiv>
            <S.ContentItemTextWrapperSpan>
              Adults
              <S.ContentItemConditionTextWrapperSpan>
                (12+ yr)
              </S.ContentItemConditionTextWrapperSpan>
            </S.ContentItemTextWrapperSpan>
            <S.ContentActionWrapperDiv>
              <S.ContentActionIconWrapperSpan
                onClick={() => {
                  if (adultCount === 1) {
                    alert('Minimum 1 adult is required');
                    return;
                  }
                  if (adultCount - 1 < roomCount) setRoomCount(roomCount - 1);
                  setAdultCount(adultCount - 1);
                }}
              >
                -
              </S.ContentActionIconWrapperSpan>
              <S.ContentActionValueWrapperSpan>{adultCount}</S.ContentActionValueWrapperSpan>
              <S.ContentActionIconWrapperSpan
                onClick={() => {
                  if (adultCount >= 16) {
                    alert('Max allowed upto 16');
                    return;
                  }
                  setAdultCount(adultCount + 1);
                }}
              >
                +
              </S.ContentActionIconWrapperSpan>
            </S.ContentActionWrapperDiv>
          </S.ContentItemWrapperDiv>
          <S.ContentItemWrapperDiv>
            <S.ContentItemTextWrapperSpan>
              Children
              <S.ContentItemConditionTextWrapperSpan>
                (0-12 yr)
              </S.ContentItemConditionTextWrapperSpan>
            </S.ContentItemTextWrapperSpan>
            <S.ContentActionWrapperDiv>
              <S.ContentActionIconWrapperSpan
                onClick={() => {
                  if (childCount < 1) {
                    alert('Not allowed');
                    return;
                  }
                  setChildCount(childCount - 1);
                  childAgeArrayInState.pop();
                  setChildAgeArrayInState(childAgeArrayInState);
                }}
              >
                -
              </S.ContentActionIconWrapperSpan>
              <S.ContentActionValueWrapperSpan>{childCount}</S.ContentActionValueWrapperSpan>
              <S.ContentActionIconWrapperSpan
                onClick={() => {
                  if (childCount > 8) {
                    alert('Not allowed');
                    return;
                  }
                  setChildCount(childCount + 1);
                  childAgeArrayInState.push(1);
                  setChildAgeArrayInState(childAgeArrayInState);
                }}
              >
                +
              </S.ContentActionIconWrapperSpan>
            </S.ContentActionWrapperDiv>
          </S.ContentItemWrapperDiv>

          {(childAgeArrayInState &&
            childAgeArrayInState.map((ageVal, index) => {
              return (
                <S.ContentItemWrapperDiv key={'childAge' + index + 1}>
                  <S.ContentItemTextWrapperSpan>
                    Child {index + 1}
                    <S.ContentItemConditionTextWrapperSpan>
                      Age
                    </S.ContentItemConditionTextWrapperSpan>
                  </S.ContentItemTextWrapperSpan>
                  <ChildAgePicker
                    val={childAgeArrayInState[index]}
                    actionHandler={actionHandler}
                    ageVal={ageVal}
                    index={index}
                  />
                  {/* <S.ContentActionDropdownWrapper>
                    <S.ContentActionValueWrapperSpan>
                      {childAgeArrayInState[index]}
                    </S.ContentActionValueWrapperSpan>
                  </S.ContentActionDropdownWrapper> */}
                </S.ContentItemWrapperDiv>
              );
            })) ||
            null}

          <S.ButtonWrapperDiv onClick={doneClickHandler}>
            <S.ButtonWrapper>Done</S.ButtonWrapper>
          </S.ButtonWrapperDiv>
        </S.ContentWrapperDiv>
      </S.WrapperDiv>
    );
  },
);

export default PaxWidget;

function ChildAgePicker({actionHandler, index, ageVal, val}) {
  const [toggleValue, toggleHandler] = useState(false);
  const childPickerRef = useRef();
  useOutsideClick(childPickerRef, () => {
    toggleHandler(false);
  });

  return (
    <>
      <S.ContentActionDropdownWrapper ref={childPickerRef} onClick={() => toggleHandler(true)}>
        <S.ContentActionValueWrapperSpan>{val}</S.ContentActionValueWrapperSpan>
        <S.ContentActionIconWrapperSpan>
          <ArrowDownIcon />
        </S.ContentActionIconWrapperSpan>
      </S.ContentActionDropdownWrapper>
      {(toggleValue && (
        <S.ChildDropdownWrap>
          {[...Array(12)].map((_, arrIndex) => (
            <li
              onClick={() => {
                actionHandler(index, arrIndex + 1);
              }}
            >
              {arrIndex + 1}
            </li>
          ))}
        </S.ChildDropdownWrap>
      )) ||
        null}
    </>
  );
}
